import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Dimensions,
	Image,
	ScrollView,
} from "react-native";
import { translate } from "react-i18next";

import BackgroundImage from "components/BackgroundImage";
import Button from "components/Button";
import Text from "components/StyledText";
import TextLink from "components/TextLink";
import ViewScroll from "components/ViewScroll";
import { DeviceRegisterIP } from "utils/config";
import Header from "components/Header";
import { getLocal } from "api";
import { signout } from "utils/awsAuth";
import { push, reset } from "utils/navigation";

import * as x from "../../../styles/css";

class Connect extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;
	static bypass = true;

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		};
		this.connected = this.connected.bind(this);
		this.logout = this.logout.bind(this);
		this.handleLayout = this.handleLayout.bind(this);
		this.home = this.home.bind(this);
	}

	componentDidMount() {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	handleLayout(evt) {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	home() {
		push({ mobile: "Home", web: "/" }, this.props, false, true);
	}

	connected() {
		this.setState(
			{
				loading: true,
			},
			() => {
				getLocal(DeviceRegisterIP)
					.then(resp => {
						reset(
							{
								web: "/deviceregister",
								mobile: "DeviceRegister",
							},
							this.props,
							true
						);
					})
					.catch(err => {
						this.setState({
							loading: false,
						});
						window.alert("Not connected to device");
					});
			}
		);
	}

	logout() {
		signout()
			.then(resp => {
				reset({ mobile: "Login", web: "/login" }, this.props);
			})
			.catch(err => {
				console.log(err);
			});
	}

	render() {
		const nav = this.props.navigation;

		const { t } = this.props;

		return (
			<ViewScroll>
				<Header>{t("deviceAuth.connect.title")}</Header>
				<Text style={[x.my.three]} help>
					{t("deviceAuth.connect.help")}
				</Text>
				<Text style={[x.my.three]} help>
					{t("deviceAuth.connect.help2")}
				</Text>
				<Text style={[x.my.three]} help>
					{t("deviceAuth.connect.help3")}
				</Text>
				<View style={[x.justifyContent.center, x.alignItems.center]}>
					<Image
						source={require("assets/control.png")}
						resizeMode="contain"
						style={[styles.image, { height: 150, width: "100%" }]}
					/>
				</View>
				{(this.state.width <= 600 && (
					<Text style={[x.my.three]} help>
						{t("deviceAuth.connect.help-settings-iphone-open")}
					</Text>
				)) || (
					<Text style={[x.my.three]} help>
						{t("deviceAuth.connect.help-settings-computer-open")}
					</Text>
				)}
				{(this.state.width <= 600 && (
					<Text style={[x.my.three]} help>
						{t("deviceAuth.connect.help-settings-iphone-click")}
					</Text>
				)) || (
					<Text style={[x.my.three]} help>
						{t("deviceAuth.connect.help-settings-computer-click")}
					</Text>
				)}
				{this.state.width <= 600 && (
					<View
						style={[
							x.justifyContent.center,
							x.alignItems.center,
							{ height: 149, width: 300 },
						]}
					>
						<Image
							source={require("assets/iphone-network.png")}
							style={[styles.image]}
						/>
					</View>
				)}
				<Text style={[x.my.three]} help>
					{t("deviceAuth.connect.help6")}
				</Text>
				<View style={[x.mt.auto]}>
					<Button
						disabled={this.state.loading}
						onPress={this.connected}
						title={t("labels.imConnected")}
						color={x.colors.default}
					/>
					<View style={[x.d.flex, x.flexDirection.row]}>
						<TextLink
							onPress={this.logout}
							title={t("labels.logout")}
							color={x.colors.default}
						/>
						<View style={[x.ml.auto]}>
							<TextLink
								onPress={this.home}
								title={t("labels.home")}
								color={x.colors.default}
							/>
						</View>
					</View>
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	image: {
		flex: 0,
	},
});

export default translate()(Connect);



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/Connect/index.js